import axios from "axios";
import { API_BASE_URL } from "./config";

// Debounce-Funktion für API-Aufrufe
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    return new Promise((resolve) => {
      timeout = setTimeout(() => resolve(func(...args)), wait);
    });
  };
};

// Erstelle eine Axios-Instanz mit Standard-Konfiguration
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Response Interceptor für einheitliche Fehlerbehandlung
axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error("API Error:", error?.response?.data || error.message);
    throw error?.response?.data || error;
  }
);

const getProfile = async () => {
  try {
    return await axiosInstance.get('/webusers/profile');
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw error;
  }
};

// Debounce profile updates to prevent rapid-fire API calls
const debouncedUpdateProfile = debounce(async (profileData) => {
  try {
    return await axiosInstance.put('/webusers/profile', profileData);
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
}, 300);

const changePassword = async (passwordData) => {
  try {
    return await axiosInstance.put('/webusers/change-password', passwordData);
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

const updateAVVStatus = async (avvData) => {
  try {
    return await axiosInstance.post('/webusers/avv-status', avvData);
  } catch (error) {
    console.error("Error updating AVV status:", error);
    throw error;
  }
};

const userProfileService = {
  getProfile,
  updateProfile: debouncedUpdateProfile,
  changePassword,
  updateAVVStatus
};

export default userProfileService;